/**
 * RequireAuth — route guard for agent-only pages.
 *
 * Wraps a route element. While the initial session check is in flight it
 * renders a minimal loading placeholder. If unauthenticated, it redirects
 * to /agent/login and stashes the attempted path in location state so
 * the login page can bounce back after sign-in.
 *
 * Usage:
 *   <Route path="/agent" element={
 *     <RequireAuth><AgentDashboard /></RequireAuth>
 *   } />
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'rgba(0,0,0,0.6)',
          fontSize: '0.95rem',
        }}
      >
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/agent/login" replace state={{ from: location }} />;
  }

  return children;
}
